import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { selector: String }

  enableAll() {
    document.querySelectorAll(this.selectorValue).forEach(el => el.checked = true)
  }

  disableAll() {
    document.querySelectorAll(this.selectorValue).forEach(el => el.checked = false)
  }
}
